import { AppState, ThunkDispatch } from "redux/store.types";
import { fetchCitiesByCountry } from "services/location/location.service";
import { fetchAreasByCity } from "services/location/location.service";
import { fetchCountries } from "services/location/location.service";
import { MapsConfigurations } from "../../types/common.types";
import {
  SET_OPERATOR_COUNTRIES,
  SET_OPERATOR_SELECTED_COUNTRY_ID
} from "../sales/operators/operators.actions";

export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_CITIES = "SET_CITIES";
export const SET_AREAS_BY_CITY = "SET_AREAS_BY_CITY";
export const SET_LOCATION_ZONE = "SET_LOCATION_ZONE";
export const SET_SELECTED_COUNTRY = "SET_SELECTED_COUNTRY";
export const SET_SELECTED_CITY = "SET_SELECTED_CITY";
export const SET_SELECTED_AREA = "SET_SELECTED_AREA ";
export const SET_CONFIGURATIONS = "SET_CONFIGURATIONS";
export const RESET_LOCATION = "RESET_LOCATION";

export const resetLocation = () => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: RESET_LOCATION });
};

export const setCountries = () => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const countries = await fetchCountries();
  if (!countries) {
    return;
  }
  const contriesObjectify = countries.reduce((acc, next) => {
    return { ...acc, [next.name]: next };
  }, {});
  dispatch({ type: SET_COUNTRIES, payload: contriesObjectify });
  dispatch({ type: SET_OPERATOR_COUNTRIES, payload: countries });
  dispatch({
    type: SET_OPERATOR_SELECTED_COUNTRY_ID,
    payload: countries[0].id
  });
};

export const resetOperatorCountries = () => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_COUNTRIES, payload: [] });
  dispatch({ type: SET_OPERATOR_COUNTRIES, payload: undefined });
  dispatch({
    type: SET_OPERATOR_SELECTED_COUNTRY_ID,
    payload: undefined
  });
};

export const setCities = (countryId: number) => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const citiesByCountry = await fetchCitiesByCountry(countryId);
  if (!citiesByCountry) {
    return;
  }
  dispatch({
    type: SET_CITIES,
    payload: { countryId, cities: citiesByCountry }
  });
};

export const setAreasByCity = (countryId: number, cityId: number) => async (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  const areasByCity = await fetchAreasByCity(cityId);
  if (!areasByCity) {
    return;
  }
  dispatch({
    type: SET_AREAS_BY_CITY,
    payload: { countryId, cityId, areas: areasByCity }
  });
};

export const setSelectedCountryId = (countryId: number) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SELECTED_COUNTRY, payload: countryId });
};

export const setSelectedCityId = (cityId: number) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SELECTED_CITY, payload: cityId });
};

export const setSelectedAreaId = (areaId: number) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_SELECTED_AREA, payload: areaId });
};

export const setMapsConfigurations = (configs: MapsConfigurations) => (
  dispatch: ThunkDispatch,
  getState: () => AppState
) => {
  dispatch({ type: SET_CONFIGURATIONS, payload: configs });
};
